var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('ChatHero'),_c('ChatAgnostic'),_c('ChatRouting'),_c('ChatTranslation'),_c('ChatScalable'),_c('RequestDemo',{attrs:{"msg":"See how Yabbr Web Chat can unify your engagement across every channel — live, intelligent, and on-brand."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }